import type { ReactNode } from 'react';

type FullPageNegativeStateProps = { message: string; subMessage?: string | ReactNode };

export const FullPageNegativeState = ({ message, subMessage }: FullPageNegativeStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[700px] w-full">
      <p className="text-header-sm">{message}</p>
      {subMessage && typeof subMessage === 'string' ? <p className="text-body-lg">{subMessage}</p> : subMessage}
    </div>
  );
};
